module.exports = __webpack_public_path__ + "static/media/home_meeting.c54770ad.png";